import * as React from 'react';
import Constants from '../../globals/Constants';
import {IAuthenticationAwareRouteProps} from './AuthenticationAwareRouteContainer';

// tslint:disable-next-line: variable-name - Justification: Components should be title cased
const AuthenticationAwareRoute: React.FC<IAuthenticationAwareRouteProps> = ({history, location, match, isLoggingIn, isAuthRequired, isLoggedIn, onLoginComplete, children}) => {
   React.useEffect(() => {
      // this should always be initialized to false in usage, it will flip to 'true' when process is complete
      if (!isLoggingIn && onLoginComplete) {
         onLoginComplete(history, location, match);
      }
   }, [isLoggingIn]);

   // just waiting for login to complete, splash screen should be handled elsewhere
   if (isLoggingIn) {
      return (<></>);
   }

   if (isAuthRequired && !isLoggedIn) {
      window.location.href = Constants.siteLinks.signin;
   }

   return (<>{children}</>);
};

export default AuthenticationAwareRoute;
